<div class="custom-switch">
    <div class="custom-switch-text">
        @if(text.orientation === "left") {
            <div class="custom-switch-text">
                @if(checked) {
                    <span class="custom-switch-text-active">{{ this.text.activeValue | titlecase }}</span>
                } @else {
                    <span class="custom-switch-text-inactive">{{ this.text.inactiveValue | titlecase }}</span>
                }
            </div>
        }
    </div>

    <input type="checkbox" class="custom-switch-check" [id]="'custom-switch-check_' + randomId" 
    [checked]="checked" [disabled]="disabled">
    <label [for]="'custom-switch-check_' + randomId" class="custom-switch-label" (click)="toogleCheck()"
    [ngClass]="{'active': checked, 'inactive': !checked}">
        
    </label>
    <div class="custom-switch-text">
        @if(text.orientation === "right") {
            <div class="custom-switch-text">
                @if(checked) {
                    <span class="custom-switch-text-active">{{ this.text.activeValue | titlecase }}</span>
                } @else {
                    <span class="custom-switch-text-inactive">{{ this.text.inactiveValue | titlecase }}</span>
                }
            </div>
        }
    </div>
</div>